import { useIsMobile } from "@/hooks/use-mobile";
import useWideLayout from "@/hooks/useWideLayout";
import { motion } from "framer-motion";

export function UpgradeLayout({ children }) {
  const isMobile = useIsMobile();
  useWideLayout(isMobile);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full bg-background rounded-xl shadow-sm overflow-hidden border border-sky-200 h-full"
    >
      {children}
    </motion.div>
  );
}
